import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'

import { SharedModule } from '@shared/shared.module'

import { NavbarComponent } from './navbar.component'
import { NavItemComponent } from './navigation/nav-item/nav-item.component'
import { NavigationComponent } from './navigation/navigation.component'

@NgModule({
  declarations: [NavbarComponent, NavigationComponent, NavItemComponent],
  imports: [RouterModule, SharedModule],
  exports: [NavbarComponent],
})
export class NavbarModule {}
